export default __webpack_public_path__ + "static/media/illustration-recruit-1-w.0d9f1f82.webp";